import React from 'react';
import VehicleStatus from '../../../components/tools/vehicleStatus/VehicleStatus';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const VehicleStatusPage = () => {

    const location = useLocation();

    return (
        <div className="vehicle-status-page-wrapper" style={{ height: '100%' }}>
            <VehicleStatus />
        </div>
    );
};

export default VehicleStatusPage;
